import $ from 'jquery';
import { initializePhoneNumberWidget } from '../../shares/phoneNumber';
import * as BookingWizard from '../booking-wizard';
import paymentGateway from '../../payment/PaymentGateway';
import hyperform from 'hyperform';
import BookingValidation from '../booking-validation/booking-validation';
import { updateBookNowAmount } from '../payment-summary/payment-summary';
const bookingValidation = new BookingValidation(window);

function registerButtonCallbacks() {
    $('#paymentContinueButton').on('click', handlePayButtonClick);
    $('#applyVoucherButton').on('click', handleVoucherButtonClick);
}

function registerCloseVoucherContainerEvent() {
    $('#closeVoucherContainer').off('click')
    $('#closeVoucherContainer').on('click', (event) => {
        event.preventDefault();
        $('.voucher-container').removeClass('active')
        $('#paymentPreview').removeClass('-top-tear-strip')
        $('#openVoucherContainer').addClass('active')
        $('.partition-payment-cover').removeClass('active')
        hyperform.reportValidity($("#FlightVoucherCode").val('').get(0) as HTMLInputElement)
    })
}

function registerVoucherContainerEvent() {
    $('#openVoucherContainer').off('click')
    $('#openVoucherContainer').on('click', (event) => {
        event.preventDefault();
        $('.voucher-container').addClass('active')
        $('#paymentPreview').addClass('-top-tear-strip')
        $('#openVoucherContainer').removeClass('active')
        $('.partition-payment-cover').addClass('active')

        registerCloseVoucherContainerEvent();
    })
}

export let initBookingReview = () => {
    registerVoucherContainerEvent();
    registerCloseVoucherContainerEvent();

    registerButtonCallbacks();

    $('.transaction-error__close').on('click', (e: JQuery.TriggeredEvent) => {
        $(e.currentTarget).parent().hide();
    });

    BookingWizard.InitializeFareConditionAdvice();
    BookingWizard.InitializePaymentInstallments();
    BookingWizard.InitializeMagnificPopup();
    BookingWizard.StickySummary();
    BookingWizard.InitializeFlightDetails();
    BookingWizard.ScrollToActionablePosition();

    initializePhoneNumberWidget();
    InitializePriceChangedPopup();
    InitializePaymentGateway();

    var voucherInput = $("#FlightVoucherCode");
    bookingValidation.attachConditionalPatternValidator(
        voucherInput.get(0) as HTMLInputElement,
        // only run validation if the element is not focused and the voucher input is open
        () => !voucherInput.is(":focus") && $(".voucher-container").hasClass("active")
    );
};

export let checkPriceChanged = () => {
    if ($('.price-changed-container').length == 1) {
        $('.price-changed-container').magnificPopup('open');
    }
};

export const updatePaymentPanel = () => {
    var form = $('#__AjaxAntiForgeryForm');
    var token = $('input[name="__RequestVerificationToken"]', form).val();

    var paymentMethod = isPayPal() ? getPaypalPaymentMethod() : getCreditPaymentMethod();
    $.ajax({
        url: "/FlightBooking/PaymentForm",
        method: "POST",
        data: {
            __RequestVerificationToken: token,
            bookingId: $('input[name=BookingId]').val(),
            paymentGateway: selectedPaymentGateway().val(),
            paymentMethod: paymentMethod
        }
    }).then(function () {
        updatePaymentSummary();
    });

  
};

export const verifyLiveBookingOnDev = (): boolean => {
    const msg = $(`#liveBookingOnDevEnabledError`);
    if (msg.length) {
        msg.show();
        return false;
    }
    return true;
}

export const verifyTermAndConditionSelected = (validationList: string[]): boolean => {
    let validCount = 0;
    validationList.forEach((value: string) => {
        const alertMessage = $(`#${value}Error`);
        if (!$(`#${value}`).prop('checked')) {
            alertMessage.show();
        } else {
            alertMessage.hide();
            validCount++;
        }
    });

    if (validCount === validationList.length) {
        return true;
    } else {
        return false;
    }
};

export const verifyPaymentOfferSelected = (): boolean => {
    return false;
};

export const InitializePriceChangedPopup = () => {
    // we define this separately from the other popups because we want different close button behavior.
    $('.price-changed-container').magnificPopup({
        delegate: '.pageload-popup-trigger',
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        showCloseBtn: false,
        midClick: true,
        closeOnBgClick: false
    });

    if ($('.js-accept-price-change').length) {
        $('.js-accept-price-change').on('click', (event: JQuery.ClickEvent) => {
            $.magnificPopup.close();
            return false;
        });
    }
};

export const InitializePaymentGateway = () => {
    $('.payment-option-container').on('click', function () {
        const control = $(this).find(':input[type="radio"]')
        if (!control.is(':checked')) {
            control.trigger('click')
        }
    })
    $('#paymentMethod').on('change', function () {
        updatePaymentPanel();
    });

    $('input[name=paymentGatewaysRadioButtonList]').on('change', function () {
        $('.payment-gateway-body').hide();
        $(this).closest(".payment-option-container").find('.payment-gateway-body').fadeToggle(300);
        updatePaymentPanel();
    })

    if ($('#cc-form-connexpay').length == 1) {
        const sdkUrl = $('#connexPaySdkUrl').val() as string;
        const publicKey = $('#publicKey').val() as string
        const deviceGuid = $('#deviceGuid').val() as string
        const bookingid = $("#bookingId").val() as string;
        const amount = parseFloat($(`#totalPaynow`)?.attr('data-total-pay-now') || '0');
        const expiration = new Date(new Date().getTime() + 30 * 60000).toISOString();
        const acceptHeader = $('input[name="ConnexPayAcceptHeader"]').val()?.toString() || '';
        $.getScript(sdkUrl).done(function () {
            paymentGateway.initConnexPay(
                $('#cc-form-connexpay'),
                $('#paymentContinueButton'),
                {
                    acceptHeader,
                    publicKey,
                    deviceGuid,
                    bookingid,
                    amount,
                    expiration
                }
            );
        });
    } else if ($('#cc-form-fatzebra').length == 1) {
        paymentGateway.initFatZebra($('#cc-form-fatzebra'));
    } else if ($('#cc-form-spreedly').length == 1) {
        $.getScript("https://core.spreedly.com/iframe/iframe-v1.min.js").done(function () {
            paymentGateway.initSpreedly(
                $('#spreedly-number'),
                $('#spreedly-cvv'),
                $('#cc-form-spreedly'),
                $('#paymentContinueButton'),
                { environmentKey: $('input[name="SpreedlyEnvironmentKey"]').val()?.toString() || '', acceptHeader: $('input[name="SpreedlyAcceptHeader"]').val()?.toString() || '' }
            );
        });
    }

}

export const handleVoucherButtonClick = async () => {
    $('#applyVoucherButton').prop('disabled', true);
    $('#FlightVoucherCode').prop('disabled', true);
    var form = $('#__AjaxAntiForgeryForm');
    var token = $('input[name="__RequestVerificationToken"]', form).val();
    var hasValidVoucher: Boolean = $('#applyVoucherButton').data('hasvalidvoucher');
    var voucherCode = $('input[name="FlightVoucherCode"]').val()?.toString() || '';

    $.ajax({
        url: !hasValidVoucher ? "/FlightBooking/ApplyVoucher" : "/FlightBooking/RemoveVoucher",
        method: "POST",
        data: {
            __RequestVerificationToken: token,
            bookingId: $('input[name=BookingId]').val(),
            voucherCode: voucherCode
        },
        success: function (result) {
            $('#paymentOptionsVoucherContainer').html(result);
            registerButtonCallbacks();
            var useVoucherPaymentMethod: Boolean = $('#UseVoucherPayment').length != 0;

            if (useVoucherPaymentMethod) {
                $('#paymentPreview').addClass('is-hidden');
                $('#payment-form-container').addClass('is-hidden');
            }
            else {
                $('#paymentPreview').removeClass('is-hidden');
                $('#payment-form-container').removeClass('is-hidden');
            }
            updatePaymentPanel();
           
        },
        complete: function () {
            hasValidVoucher = $('#applyVoucherButton').data('hasvalidvoucher');
            if (!hasValidVoucher) {
                $('#FlightVoucherCode').prop('disabled', false);
                $("#FlightVoucherCode").removeClass('validVoucher');
                $('#openVoucherContainer').addClass("active")
                $('.voucher-container').addClass("active")
                $('#openVoucherContainer').removeClass("active")
                $('#paymentPreview').addClass('-top-tear-strip')

                registerCloseVoucherContainerEvent();
            }
            else {
                $("#FlightVoucherCode").addClass('validVoucher');
            }

            $('#applyVoucherButton').prop('disabled', false);
        }
    });
}



/**
 * This handler will be called 2 times!
 * - before submitting FatZebra iFrame (trigger by user)
 * - after FatZebra return *successful* result but before POST-ing result to backend (triggered by SubmitFatZebra)
 *
 * This is the code design flaw we made to make FatZebra iFrame work with
 * WebForms and Envoy.
 *
 * Confirmed with Phuong that this behavior is fine for now and we can fix it later.
 */
export const handlePayButtonClick = () => {
    if (BookingWizard.hasSuperFareUnchecked()) {
        var form = document.getElementById('paymentofferform') as HTMLElement;
        hyperform.setRenderer('attachWarning', function (warning, element) {
            warning.classList.add('validation-error');
            warning.classList.add('hf-validation-error');
            document.getElementsByClassName('validation-container')[0].appendChild(warning);
        });
        hyperform.reportValidity(form);
        BookingWizard.ScrollToError();
        return;
    }

    if (!hyperform.reportValidity(document.getElementById("FlightVoucherCode") as HTMLInputElement)) {
        BookingWizard.ScrollToError();
        return;
    }

    if (!verifyTermAndConditionSelected(checkboxValidationElements)) {
        BookingWizard.ScrollToError();
        return;
    }

    if (!verifyLiveBookingOnDev()) {
        BookingWizard.ScrollToError();
        return;
    }

    // Call full voucher payment only if total pay now = 0
    // otherwise call other payment method
    let totalPaynow = parseFloat($(`#totalPaynow`).attr('data-total-pay-now') || '0');
    if ($('#UseVoucherPayment').length != 0 && totalPaynow == 0) {
        $('#cc-form-fullvoucher').trigger('submit');
    }
    else if (isPayPal() && $('#pp-form').length == 1) {
        $('#pp-form').trigger('submit');

    } else if ($('#cc-form-connexpay').length == 1) {
        $('#connexpay-submit-button').trigger('click');
    } else if ($('#cc-form-fatzebra').length == 1) {
        $('#cc-form-fatzebra').trigger('submit');
    } else {
        $('#cc-form-spreedly').trigger('submit');
    }
};

export const updatePaymentSummary = () => {
    $('#wait-total-price').addClass('-with-wait-indicator');
    var form = $('#__AjaxAntiForgeryForm');
    var token = $('input[name="__RequestVerificationToken"]', form).val();
    $.ajax({
        url: "/Component/GetUpdatedPaymentSummary",
        method: "POST",
        data: {
            __RequestVerificationToken: token,
            bookingId: $('input[name=BookingId]').val(),
        },
        success: function (result) {
            $('#paymentSummaryRightPanel').html(result);
            updateBookNowAmount();

        },
        complete: function () {
            $('#wait-total-price').removeClass('-with-wait-indicator');
            BookingWizard.InitializeFareConditionAdvice();
        }
    });
}

export const isPayPal = (): boolean => {
    return selectedPaymentGateway().val() === 'PayPal';
};

const selectedPaymentGateway = () =>
    $('input[name=paymentGatewaysRadioButtonList]:checked');


const getCreditPaymentMethod = () => {
    return $('.cc-container').find('input[name=paymentMethod]').val()
}
const getPaypalPaymentMethod = () => {
    return $('.pp-container').find('input[name=paymentMethod]').val()
}

const checkboxValidationElements = [
    'nameCorrectnessAcknowledgedCheckbox',
    'cancellationAndRefundCheckBox',
    'termsAndConditionsCheckBox',
];

$(initBookingReview);
$(checkPriceChanged);
